/** Registers the MarginContainer parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseMarginContainer } from './parser';
const marginContainerRegistration = {
    typeName: 'MarginContainer',
    parser: parseMarginContainer,
};
nodeRegistry.register(marginContainerRegistration);
export * from './parser';
//# sourceMappingURL=index.js.map